import { render, staticRenderFns } from "./requiredIcon.vue?vue&type=template&id=2f1eb940&"
import script from "./requiredIcon.vue?vue&type=script&lang=js&"
export * from "./requiredIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports